<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">Home</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <div v-if="successMessage" class="alert alert-success" role="alert">
        {{ successMessage }}
      </div>
      <div v-if="errorMessage" class="alert alert-danger" role="alert">
        {{ errorMessage }}
      </div>
      <h1 class="text-center">Listados de reglas aplicadas a templates del SCR</h1>
      <div v-if="showLoader" class="text-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <rules-sets-table
          :rulesSets="rulesSets"
          @error="onComponentError"
          @success="onComponentSuccess"
      />
      <div class="text-center layer-button">
        <button @click="$router.push('addRulesSet')" class="btn btn-primary">Crear nuevas reglas</button>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  import RulesSetsTable from '@/components/RulesSetsTable.vue';

  const router = useRouter();
  const rulesSets = ref([]);
  const successMessage = ref('');
  const errorMessage = ref('');
  const showLoader = ref(false);

  const initRulesSets = () => {
  showLoader.value = true;
  fetch('https://res.hotelkey.com/reservas/mvc.php/product_decision_scr_templates_web_json/RulesSets/list')
  .then(response => response.json())
  .then(data => {
  if (data.result) {
  rulesSets.value = data.data;
} else {
  setRulesSetErrorMessage();
}
})
  .catch(() => {
  setRulesSetErrorMessage();
})
  .finally(() => {
  showLoader.value = false;
});
  };

  const onComponentError = (message) => {
  successMessage.value = '';
  errorMessage.value = message;
  scrollToTop();
  initRulesSets();
};

  const onComponentSuccess = (message) => {
  errorMessage.value = '';
  successMessage.value = message;
  scrollToTop();
  initRulesSets();
};

  const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

  const setRulesSetErrorMessage = () => {
  errorMessage.value = "Se ha producido un error al consultar las reglas.";
};

  onMounted(initRulesSets);
</script>

<style>
.layer-button {
  padding: 20px;
}
</style>
